import React, { useState, useEffect, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaBars, FaTimes, FaUser, FaCalculator, FaHome, FaInfoCircle, FaTag } from 'react-icons/fa';
import { useAuth } from '../../auth/AuthProvider';
import './TopNav.css';

const TopNav = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { user, signOut } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

  const toggleMenu = useCallback(() => {
    setIsMenuOpen(prev => !prev);
  }, []);

  const handleSignOut = useCallback(async () => {
    try {
      await signOut();
      navigate('/login');
    } catch (error) {
      console.error('Error signing out:', error);
    }
  }, [signOut, navigate]);

  const handleNavigation = useCallback((path) => {
    if (path === location.pathname) {
      setIsMenuOpen(false);
      window.scrollTo(0, 0);
      return;
    }
    navigate(path);
    setIsMenuOpen(false);
  }, [location.pathname, navigate]);

  // Hide navigation on password update page
  if (location.pathname === '/update-password') {
    return null;
  }

  const navItems = [
    { path: '/', label: 'Home', icon: <FaHome /> },
    ...(user ? [
      { path: '/calculations', label: 'Calculator', icon: <FaCalculator /> },
      { path: '/profile', label: 'Profile', icon: <FaUser /> },
      { path: '/pricing', label: 'Pricing', icon: <FaTag /> },
      { path: '/about-contact', label: 'About & Contact', icon: <FaInfoCircle /> },
    ] : [
      { path: '/pricing', label: 'Pricing', icon: <FaTag /> },
      { path: '/about-contact', label: 'About & Contact', icon: <FaInfoCircle /> },
    ])
  ];

  return (
    <>
      <nav className="top-nav">
        <div className="nav-content">
          <button
            className="menu-button"
            onClick={toggleMenu}
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <FaTimes /> : <FaBars />}
          </button>
          
          <button
            className="logo-button"
            onClick={() => handleNavigation('/')}
          >
            <img 
              src="/logo_634x480.png" 
              alt="Pre Go Prep" 
              className="nav-logo"
            />
          </button>

          {/* Desktop Navigation */}
          <div className="desktop-nav">
            {navItems.map((item) => (
              <button
                key={item.path}
                onClick={() => handleNavigation(item.path)}
                className={`nav-item ${location.pathname === item.path ? 'active' : ''}`}
              >
                {item.icon}
                {item.label}
              </button>
            ))}
            {!user ? (
              <>
                <button
                  onClick={() => handleNavigation('/login')}
                  className="nav-item"
                >
                  Sign In
                </button>
                <button
                  onClick={() => handleNavigation('/signup')}
                  className="nav-item sign-up-button"
                >
                  Get Started
                </button>
              </>
            ) : (
              <button
                onClick={handleSignOut}
                className="sign-out-button"
              >
                Sign Out
              </button>
            )}
          </div>
        </div>
      </nav>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="mobile-menu">
          {navItems.map((item) => (
            <button
              key={item.path}
              onClick={() => handleNavigation(item.path)}
              className={`mobile-nav-item ${location.pathname === item.path ? 'active' : ''}`}
            >
              {item.icon}
              {item.label}
            </button>
          ))}
          {!user ? (
            <>
              <button
                onClick={() => {
                  handleNavigation('/login');
                  setIsMenuOpen(false);
                }}
                className="mobile-nav-item"
              >
                Sign In
              </button>
              <button
                onClick={() => {
                  handleNavigation('/signup');
                  setIsMenuOpen(false);
                }}
                className="mobile-nav-item sign-up-button"
              >
                Get Started
              </button>
            </>
          ) : (
            <button
              onClick={() => {
                handleSignOut();
                setIsMenuOpen(false);
              }}
              className="mobile-sign-out-button"
            >
              Sign Out
            </button>
          )}
        </div>
      )}
    </>
  );
};

export default TopNav; 